import * as PropTypes from "prop-types";
import classNames from "classnames";
import KeyHandler, { KEYPRESS } from "react-key-handler";
import interactiveMapStyles from "./InteractiveMap.css";

import { KEYCODES } from "/javascripts/constants/keyCodes";
import { withViewport } from "/react/utils/withViewport";

import {
  ButtonLink,
  ButtonWithText,
  HeadingSubHeader,
  ToFullscreenAnimation,
  MarkersMap,
} from "/react/library/";

@withViewport()
export class InteractiveMap extends React.Component {
  static propTypes = {
    markers: PropTypes.array.isRequired,
    centerCoordinates: PropTypes.object.isRequired,
    title: PropTypes.string,
    fullscreenMode: PropTypes.bool,
    button: PropTypes.object.isRequired,
    zoom: PropTypes.number,
    displayOnlyFullscreenMap: PropTypes.bool,
  };

  state = {
    isMounted: false,
    isFullscreen: false,
    hideMap: false,
  };

  containerRef = React.createRef();

  async componentDidMount() {
    // Dynamically import because "window" is not defined when using SSR
    const module = await import("/javascripts/bus");
    this.bus = module.default;

    this.setState({ isMounted: true });

    const { fullscreenMode } = this.props;

    if (fullscreenMode) {
      this.setState({ hideMap: true });
    }
  }

  handleOnClickFullscreen = (event) => this.toggleFullscreen();

  openFullScreenMap = () => {
    this.setState({ hideMap: false }, () => {
      if (!this.state.hideMap) {
        this.toggleFullscreen();
      }
    });
  };

  toggleFullscreen = () => {
    const { isFullscreen } = this.state;

    this.setState({ isFullscreen: !isFullscreen });

    this.bus && this.bus.emit("onToggleHeader", !isFullscreen);
  };

  closeFullscreen = (event) => {
    this.setState({ hideMap: true }, () => {
      this.toggleFullscreen();
      if (!this.props.displayOnlyFullscreenMap)
        this.setState({ hideMap: false });
    });
  };

  render() {
    const { isMounted, isFullscreen, hideMap } = this.state;
    const { markers, title, centerCoordinates, fullscreenMode, zoom, isFlightInstructorMap } =
      this.props;

    if (!isMounted) return null;

    return (
      <div>
        {fullscreenMode && (
          <div className={interactiveMapStyles.textCenter}>
            {this.props.button.ID ? (
              <button
                onClick={this.openFullScreenMap}
                className={interactiveMapStyles.fullScreenImageButton}
                aria-label="Open FullScreen Map"
              >
                <img
                  alt={this.props.button.alt}
                  src={this.props.button.url}
                  srcSet={this.props.button.url}
                  className={interactiveMapStyles.fullScreenImageButtonImg}
                />
              </button>
            ) : (
              <ButtonWithText
                onClick={this.openFullScreenMap}
                className={interactiveMapStyles.fullScreenButton}
              >
                Open map
              </ButtonWithText>
            )}
          </div>
        )}

        {!hideMap && (
          <div
            className={classNames(interactiveMapStyles.container, {
              [interactiveMapStyles.isFullscreen]: isFullscreen,
            })}
            ref={this.containerRef}
          >
            <div>
              {title && (
                <div className={interactiveMapStyles.header}>
                  <HeadingSubHeader isLight>{title}</HeadingSubHeader>
                </div>
              )}

              <div className={interactiveMapStyles.footer}>
                {this.props.viewportIsLaptopOrBigger ? (
                  <ButtonLink isLight onClick={this.handleOnClickFullscreen}>
                    Full screen
                  </ButtonLink>
                ) : (
                  <ButtonWithText
                    isLight
                    onClick={this.handleOnClickFullscreen}
                  >
                    Open map
                  </ButtonWithText>
                )}
              </div>

              {isFullscreen && (
                <React.Fragment>
                  <ToFullscreenAnimation
                    animationFrameTarget={this.containerRef.current}
                    closeFullscreenCallback={this.closeFullscreen}
                    fadeContentIn
                    content={
                      <MarkersMap
                        title={title}
                        centerCoordinates={centerCoordinates}
                        markers={markers}
                        isFullscreen={isFullscreen}
                        zoom={zoom}
                        isFlightInstructorMap={isFlightInstructorMap}
                      />
                    }
                  />
                  <KeyHandler
                    keyEventname={KEYPRESS}
                    code={KEYCODES.ESC}
                    onKeyHandle={this.closeFullscreen}
                  />
                </React.Fragment>
              )}

              <MarkersMap
                title={title}
                centerCoordinates={centerCoordinates}
                markers={markers}
                isFullscreen={false}
                zoom={zoom}
                isFlightInstructorMap={isFlightInstructorMap}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
